// --- smooth scroll --------------

// lenis smooth scroll
// const lenis = new Lenis({
//   smoothWheel: true, // Smooth wheel behavior
//   smoothTouch: false, // Disable smooth touch scrolling (if needed)
//   normalizeWheel: true, // Normalize wheel events
//   // Ignore elements with the class 'scroll-section' (or any other class you use)
//   ignore: (el) => el.classList.contains("scroll-section"),
// });

// lenis.on("scroll", ScrollTrigger.update);
// gsap.ticker.add((time) => {
//   lenis.raf(time * 700);
// });

gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------

//size-chart 
function toggleSizeChart(el){
    const mainProduct = el.closest("product-info");
    const currentChart = mainProduct.querySelector("#sizeChart");
    currentChart.classList.toggle("active");
    document.addEventListener("scroll", () => {
      if (currentChart.classList.contains("active")) {
        currentChart.classList.remove("active");
      }
    });
  }

//size-chart

// =============== Header color change ==============

// gsap.registerPlugin(ScrollTrigger);

// const header = document.querySelector(".header_main");

// ScrollTrigger.matchMedia({
//   "(min-width: 1024px)": function () {
//     ScrollTrigger.create({
//       start: "top -1",
//       onEnter: () =>
//         gsap.to(header, {
//           backdropFilter: "blur(30px)",
//           backgroundColor: "rgba(29, 28, 28, 0.48)", // #1d1c1c7a
//           duration: 0.3,
//           ease: "power1.out"
//         }),
//       onLeaveBack: () =>
//         gsap.to(header, {
//           backdropFilter: "blur(0px)",
//           backgroundColor: "transparent",
//           duration: 0.3,
//           ease: "power1.out"
//         })
//     });
//   }
// });


// const header = document.querySelector(".header_main");

// // Desktop breakpoint (aap change kar sakte ho)
// const isDesktop = window.matchMedia("(min-width: 950px)").matches;

// // Check if this is home page
// const isHome = window.location.pathname === "/";

// if (header && isDesktop && isHome) {
//   function checkTop() {
//     if (window.scrollY <= 0) {
//       header.classList.add("is-top");
//     } else {
//       header.classList.remove("is-top");
//     }
//   }

//   window.addEventListener("scroll", checkTop);
//   checkTop(); // initial check
// } else if (header) {
//   // Mobile / tablet ya non-home → default state
//   header.classList.remove("is-top");
// }



// =================================== for dots ========================




// function snapScrollLeft(el){
//     const mediaWrapper = el.closest(".card__inner");
//     const dotsWrapper = mediaWrapper.querySelector(".card-img-dots");
//     const galleryWrapper = mediaWrapper.querySelector(".card-img-ul");
    
//     const imgCount = dotsWrapper.querySelectorAll("li").length;
//     const galleryWidth = galleryWrapper.scrollWidth;
//     const scrollAmount = galleryWidth / imgCount;
    
//     galleryWrapper.scrollBy({ 
//         left: -scrollAmount, 
//         behavior: "smooth" 
//     });
    
//     const current = dotsWrapper.querySelector("li.active");
//     const previous = current.previousElementSibling;
//     const previoustoPrev = previous ? previous.previousElementSibling : null;
//     const next = el.nextElementSibling;

//     if (previous) {
//         current.classList.remove("active");
//         previous.classList.add("active");
//     }
    
//     if(next){
//         next.style.opacity = "1";
//     }
    
//     if(!previoustoPrev){
//         el.style.opacity = "0";
//     }
// }


// function snapScrollRight(el){
//     const mediaWrapper = el.closest(".card__inner");
//     const dotsWrapper = mediaWrapper.querySelector(".card-img-dots");
//     const galleryWrapper = mediaWrapper.querySelector(".card-img-ul");
    
//     const imgCount = dotsWrapper.querySelectorAll("li").length;
//     const galleryWidth = galleryWrapper.scrollWidth;
//     const scrollAmount = galleryWidth / imgCount;
    
//     galleryWrapper.scrollBy({ 
//         left: scrollAmount, 
//         behavior: "smooth" 
//     });
    
//     const current = dotsWrapper.querySelector("li.active");
//     const prev = el.previousElementSibling;
//     const next = current.nextElementSibling;
//     const nexttoNext = next ? next.nextElementSibling : null;
    
//     if (next) {
//         current.classList.remove("active");
//         next.classList.add("active");
//     }
    
//     if(prev){
//         prev.style.opacity = "1";
//     }
    
//     if(!nexttoNext){
//         el.style.opacity = "0";
//     }
// }



// // -------------------------------------------
// // iOS-SAFE REPLACEMENT FOR THE "scrollend" EVENT
// // -------------------------------------------

// function onScrollEnd(element, callback, delay = 120) {
//     let timeout;
//     element.addEventListener("scroll", () => {
//         clearTimeout(timeout);
//         timeout = setTimeout(() => {
//             callback();
//         }, delay);
//     });
// }



// // ---------------------
// // DOTS + BUTTON SYNCING
// // ---------------------

// function connectDotsChange(){
//     const Cardcontainer = document.querySelectorAll('.card-img-ul');
    
//     Cardcontainer.forEach(card => {
//         const cardWrapper = card.closest(".card");
//         const cardDots = cardWrapper.querySelector(".card-img-dots");
//         const items = card.querySelectorAll('.card-img-ul li');
        
//         // REPLACED scrollend → onScrollEnd
//         onScrollEnd(card, () => {
//             const liWid = card.clientWidth;
//             const snapLi = Math.round(card.scrollLeft / liWid) + 1;
            
//             // Update dots
//             cardDots.querySelector("li.active")?.classList.remove("active");
//             cardDots
//             .querySelector(`li[data-val='${snapLi}']`)
//             ?.classList.add("active");
            
//             // Left button visibility
//             const leftBtn = cardWrapper.querySelector('.ci-left-btn');
//             leftBtn.style.opacity = snapLi === 1 ? "0" : "1";
            
//             // Right button visibility
//             const rightBtn = cardWrapper.querySelector('.ci-right-btn');
//             rightBtn.style.opacity = snapLi === items.length ? "0" : "1";
//         });
//     });
// }



// // ---------------------
// // OBSERVER FOR DYNAMIC CONTENT
// // ---------------------

// function setCardDots(elTag){
//     new MutationObserver(() => {
//         connectDotsChange();
//     }).observe(elTag, {
//         childList: true,
//         subtree: true,
//     });
// }



// // ---------------------
// // INITIALIZATION
// // ---------------------

// document.addEventListener("DOMContentLoaded", () => {
//     connectDotsChange();
    
//     if (location.pathname.includes("/collections/")) {
//         const filtData = document.querySelector('aside');
//         if (filtData) setCardDots(filtData);
//     }
    
//     if (location.pathname.includes("/products/")) {
//         const filtData = document.querySelector('product-recommendations');
//         if (filtData) setCardDots(filtData);
//     }
// });


// image-new-slider
document.addEventListener("DOMContentLoaded",()=>{
const target = document.querySelector("product-recommendations");

if (target) {
  const observer = new MutationObserver((mutations,obs) => {
    for (const mutation of mutations) {
        obs.disconnect();
      if (mutation.type === "childList") {
            document.querySelectorAll('.productSwiper').forEach((slider) => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
        break;
      }
    }
  });

  observer.observe(target, {
    childList: true, // watch children add/remove
  });
}
const collectionProducts = document.querySelector(".active-facets.active-facets-desktop");
if (collectionProducts) {
  const observer = new MutationObserver((mutations,obs) => {
    for (const mutation of mutations) {
            document.querySelectorAll('.productSwiper').forEach((slider) => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
        break;
    }
  });

  observer.observe(collectionProducts, {
    childList: true, // watch children add/remove,
    subtree: true,
  });
}


document.querySelectorAll('.productSwiper').forEach((slider) => {
      new Swiper(slider, {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  allowTouchMove: true, // ✅ enable touch
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: slider.querySelector('.swiper-button-next'),
    prevEl: slider.querySelector('.swiper-button-prev'),
  },
});

    });

    // for product-rec

});

//================================= for dots ============================================= 




//  scroll-down and background-color change in info
// if (window.location.pathname.includes("/products/") && window.innerWidth >= 950) {
//     const section = document.querySelector(".product_info_main-wrapper");

//     if (section) {
//         window.addEventListener("scroll", function () {
//             if (window.scrollY > 50) {
//                 section.style.backgroundColor = "#fff";
//             } else {
//                 section.style.backgroundColor = "";
//             }
//         });
//     }
// }

//  scroll-down and background-color change in info



// //  for remove quickadd 


// document.addEventListener("click", function (e) {
//     const quickAddModal = document.querySelector("quick-add-modal[open], .quick-add-modal.open");
//     if (!quickAddModal) return;

//     const content = quickAddModal.querySelector(".product__info-wrapper .product__info-container");
//     const sizeChart = quickAddModal.querySelector(".size-chart-wrapper");
//     const formLabels = quickAddModal.querySelectorAll(".product-form__input label");
//     const variantInputs = quickAddModal.querySelectorAll('select[name="id"], input[name="id"]');

//     // allowed areas → do nothing
//     if (
//         (content && content.contains(e.target)) ||
//         (sizeChart && sizeChart.contains(e.target)) ||
//         Array.from(formLabels).some(label => label.contains(e.target)) ||
//         Array.from(variantInputs).some(input => input.contains(e.target)) 
//     ) {
//         return;
//     }

//     quickAddModal.removeAttribute("open");
//     quickAddModal.classList.remove("open");
 
// });






// //  for remove quickadd 



// menu
const menuToggle = document.getElementById("menuToggle");
const menuWrapper = document.querySelector(".header_bottom_menu");
const subMenu = document.querySelector(".sub_menu");
// const closeBtn = document.querySelector(".menu_close");

menuToggle.addEventListener("click", () => {
  menuWrapper.classList.toggle("active");
  subMenu.classList.toggle("active");
});

// closeBtn.addEventListener("click", () => {
//   menuWrapper.classList.remove("active");
//   subMenu.classList.remove("active");
// });

// menu


// search
document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth <= 950) return; // 👈 condition

  const searchEl = document.querySelector('details-modal.header__search>details');
  const headerMain = document.querySelector('header.header .header_main');

  if (!searchEl || !headerMain) return;

  new MutationObserver(() => {
    const isOpen = searchEl.hasAttribute("open");
    headerMain.classList.toggle("open-search", isOpen);
  }).observe(searchEl, {
    attributes: true,
    attributeFilter: ['open']
  });

});

document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth <= 950) return; // 👈 condition

  const searchElMob = document.querySelector(
    '.cust_header_wrapper_mob_details_right .header__search>details'
  );
  const headerMain = document.querySelector('.cstm_main_header');

  if (!searchElMob || !headerMain) return;

  new MutationObserver(() => {
    const isOpen = searchElMob.hasAttribute("open");
    headerMain.classList.toggle("open-search", isOpen);
  }).observe(searchElMob, {
    attributes: true,
    attributeFilter: ['open']
  });

});
// search


// Filter 

  const filter = document.querySelector(".mobile-facets__disclosure");
  const facets = document.querySelectorAll(".mobile-facets__details");

  filter && filter.addEventListener("click", () => {
    facets.forEach((facet) => {
      facet.setAttribute("open", true);
    })
  })



// Filter 


// ---------- MOUSE SCROLL-X ----------

function enableLeftClickDragScroll(container) {
    if (!container) return;

    let isDragging = false,
        dragStarted = false,
        startX = 0,
        scrollStart = 0,
        currentX = 0,
        lastX = 0,
        velocity = 0,
        raf = null;

    const dragThreshold = 5;

    function renderMomentum() {
        scrollStart -= velocity;
        container.scrollLeft = scrollStart;
        velocity *= 0.95; 

        if (Math.abs(velocity) > 0.5) {
            raf = requestAnimationFrame(renderMomentum);
        } else {
            cancelAnimationFrame(raf);
        }
    }

    container.addEventListener("mousedown", e => {
        if (e.button !== 0) return;
        isDragging = true;
        dragStarted = false;
        startX = lastX = e.pageX;
        scrollStart = container.scrollLeft;
        container.classList.add("is-dragging");
        cancelAnimationFrame(raf);
        e.preventDefault();
    });

    container.addEventListener("mousemove", e => {
        if (!isDragging) return;
        currentX = e.pageX;
        const delta = currentX - lastX;
        velocity = delta;

        if (!dragStarted && Math.abs(currentX - startX) > dragThreshold) {
            dragStarted = true;
        }

        if (dragStarted) {
            scrollStart -= delta;
            container.scrollLeft = scrollStart;
        }

        lastX = currentX;
    });

    function endDrag() {
        if (!isDragging) return;
        isDragging = false;
        container.classList.remove("is-dragging");

        // momentum
        raf = requestAnimationFrame(renderMomentum);
    }

    container.addEventListener("mouseup", endDrag);
    container.addEventListener("mouseleave", endDrag);

    container.addEventListener("click", e => {
        if (dragStarted) {
            e.preventDefault();
            e.stopPropagation();
            dragStarted = false;
        }
    });

    container.classList.add("is-draggable");
}

function waitForElementAndInit(selector) {
    document.querySelectorAll(selector).forEach(el => {
        if (!el._dragInitialized) {
            enableLeftClickDragScroll(el);
            el._dragInitialized = true;
        }
    });

    new MutationObserver(mutations => {
        for (const mutation of mutations) {
            mutation.addedNodes.forEach(node => {
                if (node instanceof HTMLElement) {
                    if (node.matches(selector) && !node._dragInitialized) {
                        enableLeftClickDragScroll(node);
                        node._dragInitialized = true;
                    }
                    node.querySelectorAll?.(selector)?.forEach(el => {
                        if (!el._dragInitialized) {
                            enableLeftClickDragScroll(el);
                            el._dragInitialized = true;
                        }
                    });
                }
            });
        }
    }).observe(document.body, {
        childList: true,
        subtree: true
    });
}

document.addEventListener("DOMContentLoaded", () => {
    [".gallery_hero_container"].forEach(selector => {
        waitForElementAndInit(selector);
    });
});

// ---------- MOUSE SCROLL-X ----------




document.addEventListener("DOMContentLoaded", function () {
  const isHomenew = window.location.pathname === "/";
  const homeIcon = document.querySelector(".home_icon_wrapper");

  if (isHomenew) {
    homeIcon?.classList.add("home-active");
  } else {
    homeIcon?.classList.remove("home-active");
  }
});


  // Wait for DOM to load
  document.addEventListener("DOMContentLoaded", function() {
    const header = document.querySelector('.header_mobile');

    // Check current page path
    if (window.location.pathname !== "/") {
      // Agar home page nahi hai, extra class add karo
      header.classList.add("not-home");
    } else {
      // Agar home page hai, extra class remove karo
      header.classList.remove("not-home");
    }
  });



// document.addEventListener('DOMContentLoaded', () => {
//   const header = document.querySelector('.header');
//   let lastScrollY = window.scrollY;

//   const mq = window.matchMedia('(min-width: 950px)');

//   const handleScroll = () => {
//     const currentY = window.scrollY;

//     if (mq.matches) {
//       // ===== DESKTOP =====
//       if (currentY <= 0) {
//         header.classList.add('is-at-top');
//         header.classList.remove('is-scrolled', 'is-scroll-up');
//       } 
//       else if (currentY > lastScrollY && currentY > 20) {
//         header.classList.add('is-scrolled');
//         header.classList.remove('is-scroll-up', 'is-at-top');
//       } 
//       else if (currentY < lastScrollY) {
//         header.classList.add('is-scroll-up');
//         header.classList.remove('is-scrolled', 'is-at-top');
//       }

//     } else {
//       // ===== MOBILE =====
//       if (currentY <= 0) {
//         header.classList.add('is-at-top');
//         header.classList.remove('is-scrolled', 'is-scroll-up');
//       } 
//       else if (currentY > lastScrollY && currentY > 20) {
//         header.classList.add('is-scrolled');
//         header.classList.remove('is-scroll-up', 'is-at-top');
//       } 
//       else if (currentY < lastScrollY) {
//         header.classList.add('is-scroll-up');
//         header.classList.remove('is-scrolled', 'is-at-top');
//       }
//     }

//     lastScrollY = currentY;
//   };

//   handleScroll();

//   window.addEventListener('scroll', handleScroll, { passive: true });
//   mq.addEventListener('change', handleScroll);
// });  





// wishlist

document.addEventListener('click', function(e) {
  if(e.target.classList.contains("swym-variant-selector-modal-background")){
    e.target.querySelector("#swym-vs-close-popup").click();
  }  
})

// wishlist

// document.addEventListener('DOMContentLoaded', function () {

//   const starBox = document.querySelector('.cust-star-review');

//   if (!starBox) return;

//   starBox.addEventListener('click', function () {

//     const modal = document.querySelector('.jdgm-write-review-modal');

//     if (modal) {
//       modal.style.display = 'block';
//     }

//   });

// });



// document.addEventListener('DOMContentLoaded', function () {

//   const starBox = document.querySelector('.cust-star-review');

//   if (!starBox) return;

//   starBox.style.cursor = 'pointer';

//   starBox.addEventListener('click', function () {

//     const reviewSection = document.querySelector(
//       '[data-widget-container="review-widget"]'
//     );

//     if (!reviewSection) {
//       console.log('Review section NOT found');
//       return;
//     }

//     reviewSection.scrollIntoView({
//       behavior: 'smooth',
//       block: 'start'
//     });

//   });

// });